import React from 'react';
import { EmployerLogin } from './employer-login.view';
import { EmployerLoginProvider } from './employer-login.provider';

type EmployerLoginFeatureProps = {
   captchaKey: string | null;
};

export const EmployerLoginFeature = ({ captchaKey }: EmployerLoginFeatureProps) => {
   return (
      <EmployerLoginProvider>
         <EmployerLogin captchaKey={captchaKey}></EmployerLogin>
      </EmployerLoginProvider>
   );
};
